// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'invoice.term': 'Due on receipt | {count} days',

    'invoice.page.title': 'Invoices',
    'invoice.page.search_results': 'Search Results',
    'invoice.page.create.title': 'New Invoice',
    'invoice.page.search.title': 'Find Invoices',
    'invoice.page.edit.title': 'Edit Invoice',
    'invoice.page.title.duplicate': 'Duplicate Invoice',
    'invoice.page.edit.email': 'Email Invoice',
    'invoice.page.view.history': 'Audit Trail',
    'invoice.page.all': 'All',

    'invoice.button.cancel': 'Cancel',
    'invoice.button.select': 'Select',
    'invoice.button.find': 'Find Invoices',
    'invoice.button.search': 'Apply',
    'invoice.button.create': 'Save Changes',
    'invoice.button.draft': 'Save as Draft',
    'invoice.button.pro_forma': 'Save as Pro Forma',
    'invoice.button.print': 'Print',
    'invoice.button.email': 'Email Invoice',
    'invoice.button.send_email': 'Send Email',
    'invoice.button.new': 'New Invoice',
    'invoice.button.cancel_draft': 'Cancel Draft',
    'invoice.button.void': 'Void Invoice',
    'invoice.button.rollback': 'Rollback Invoice',
    'invoice.button.save': 'Save Changes',
    'invoice.button.delete': 'Permanently Delete',
    'invoice.button.edit': 'Edit',
    'invoice.button.restore': 'Restore',
    'invoice.button.refund': 'Refund',
    'invoice.button.reset': 'Reset',
    'invoice.button.record_payment': 'Record Payment',
    'invoice.button.history': 'Audit Trail',
    'invoice.button.issue_memo': 'Issue Memo',
    'invoice.button.credit_memo': 'View Credit Memo',
    'invoice.button.duplicate': 'Duplicate',
    'invoice.button.confirm': 'Confirm',

    'invoice.placeholder.search': 'Search invoices',
    'invoice.placeholder.search_items': 'Search items',

    'invoice.message.no_change': 'This invoice has not changed since it was created.',

    'invoice.link.create_first_invoice': 'Click here to create your first invoice',
    'invoice.link.invoices': ' Return to Invoices',
    'invoice.link.retry': 'Click here to retry',

    'invoice.checkbox.all': 'Check All',
    'invoice.checkbox.actions_label': 'with selected',

    'invoice.label.items': 'Invoice Items',
    'invoice.label.recent': 'Recent',
    'invoice.label.popular': 'Popular',
    'invoice.label.date': 'Date',
    'invoice.label.due': 'Due',
    'invoice.label.item': 'Item',
    'invoice.label.description': 'Description',
    'invoice.label.add_description': 'Add Description',
    'invoice.label.unit_cost': 'Unit Cost',
    'invoice.label.quantity': 'Quantity',
    'invoice.label.total': 'Total',
    'invoice.label.tax_total': 'Tax Total',
    'invoice.label.grand_total': 'Grand Total',
    'invoice.label.sub_total': 'Subtotal',
    'invoice.label.discount': 'Discount',
    'invoice.label.add_discount': 'Add Discount',

    'invoice.label.bill_to': 'Bill To',
    'invoice.label.balance': 'Balance',
    'invoice.label.subject': 'Subject',
    'invoice.label.to': 'To',
    'invoice.label.message': 'Message',
    'invoice.label.no_items': 'No items found',
    'invoice.label.void_reason': 'Reason for voiding invoice',
    'invoice.label.cancel_reason': 'Reason for canceling invoice',
    'invoice.label.refund_reason': 'Reason for refunding invoice',
    'invoice.label.rollback_reason': 'Reason for rolling back invoice',

    'invoice.label.invoice_number': 'Invoice No',
    'invoice.label.issue_credit': 'Give store credit',
    'invoice.label.issue_refund': 'Issue Refund',

    'invoice.label.draft_invoice': 'Draft Invoice',
    'invoice.label.proforma_invoice': 'Pro Forma Invoice',
    'invoice.label.tax_invoice': 'Tax Invoice',

    'invoice.label.title': 'Title',
    'invoice.label.refunded_on': 'Refund On',

    'invoice.label.from__transaction_date': 'From transaction date',
    'invoice.label.to__transaction_date': 'To transaction date',
    'invoice.label.transaction_date': 'Invoice Date',
    'invoice.label.last_updated': 'Last updated',

    'invoice.label.printed_at': 'Printed At',
    'invoice.label.opened_at': 'Opened At',
    'invoice.label.paid_at': 'Paid At',
    'invoice.label.due_at': 'Due Date',

    'invoice.label.bill_to_entity_name': 'Bill To',
    'invoice.label.bill_to_contact_name': 'Bill To Contact',
    'invoice.label.bill_to_address': 'Bill To Address',
    'invoice.label.ship_to_contact_name': 'Ship To Contact',
    'invoice.label.ship_to_address': 'Ship To Address',
    'invoice.label.purchase_order_number': 'Purchase Order #',
    'invoice.label.term': 'Term',
    'invoice.label.currency_name': 'Currency',
    'invoice.label.currency_sub_total_in_cents': 'Subtotal',
    'invoice.label.currency_discount_total_in_cents': 'Discount Total',
    'invoice.label.currency_tax_total_in_cents': 'Tax Total',
    'invoice.label.currency_grand_total_in_cents': 'Grand Total',
    'invoice.label.currency_balance_owing_in_cents': 'Balance Owing',
    'invoice.label.currency_shipping_total_in_cents': 'Shipping Total',
    'invoice.label.latest_trading_date': 'Latest Trading Date',
    'invoice.label.rates_not_set': 'Custom rates not set',

    'invoice.label.sold_by': 'Sales Person',
    'invoice.label.public_customer_message': 'Public Customer Message',
    'invoice.label.private_note': 'Private Note',
    'invoice.label.reference_number': 'Reference Number',
    'invoice.label.is_exported': 'Exported',
    'invoice.label.exported': 'EXPORTED',
    'invoice.label.scheduled': 'SCHEDULED',

    'invoice.label.created_at': 'Created on',

    'invoice.label.status': 'Status',

    'invoice.sort.field_label': 'Field',
    'invoice.sort.direction_label': 'Direction',
    'invoice.sort.direction_ascending': 'Ascending',
    'invoice.sort.direction_descending': 'Descending',

    'invoice.modal.title.invoice_void': 'Void Invoice',
    'invoice.modal.title.invoice_cancel': 'Cancel Draft Invoice',
    'invoice.modal.title.invoice_rollback': 'Rollback Invoice',
    'invoice.modal.title.invoice_refund': 'Refund Invoice',
    'invoice.modal.title.invoice_restore': 'Restore Invoice',
    'invoice.modal.title.using_custom_rates': 'Custom Exchange rates',

    'invoice.modal.message.using_custom_rates': 'Please double check your foreign currency rates to ensure they are accurate before saving.<br/> <br/> Are your rates up to date?',
    'invoice.modal.message.invoice_cancel': 'Are you sure that you want to cancel this draft? This action cannot be undone.| Are you sure that you want to cancel these drafts? This action cannot be undone.',
    'invoice.modal.message.invoice_void':
        'Are you sure that you want to void this invoice? This action cannot be undone and a credit note will be issued for payments. | Are you sure that you want to void these invoices? This action cannot be undone and a credit note will be issued for payments.',
    'invoice.modal.message.invoice_rollback': 'Are you sure that you want to rollback this invoice? This action cannot be undone. | Are you sure that you want to void these invoices? This action cannot be undone',
    'invoice.modal.message.invoice_restore': 'Are you sure that you want to restore this invoice? | Are you sure that you want to restore these invoices?',
    'invoice.modal.message.invoice_refund': 'Are you sure that you want to refund this invoice? | Are you sure that you want to refund these invoices?',

    'invoice.success.message.invoice_created': 'Your invoice has been created',
    'invoice.success.message.invoice_updated': 'Your invoice has been updated',
    'invoice.success.message.invoice_cancelled': 'Your draft invoice has been cancelled',
    'invoice.success.message.invoice_voided': 'Your invoice has been voided',
    'invoice.success.message.invoice_rolled_back': 'Your invoice has been rolled back',
    'invoice.success.message.invoice_restored': 'Your invoice has been restored | All selected invoices were restored',
    'invoice.success.message.invoice_refunded': 'Your invoice has been refunded | All selected invoices were refunded',
    'invoice.success.message.invoice_deleted': 'Your invoice has been permanently deleted | All selected invoices were permanently deleted',

    'invoice.error.message.invoice_deleted': 'This invoice was already permanently deleted | These invoices were already permanently deleted',
    'invoice.error.message.invoice_restored': 'This invoice was already restored | These invoices were already restored',
    'invoice.error.message.error_loading_page': 'Sorry, there was an error loading invoice.| Sorry, there was an error loading invoices.',
    'invoice.error.message.error_loading_items': 'Sorry, there was an error loading the item list.| Sorry, there was an error loading the item lists.',

    'invoice.error.message.edit_not_allowed': "The invoice has been updated and can't be saved.",
    'invoice.error.message.entity_email_missing': "{name} doesn't have an email address, please add their email address.",
    'invoice.error.message.entity_email_invalid': "{name} doesn't have a valid email, please add their correct email address.",

    'invoice.modal.title.email_invoice': 'Email Invoice',
    'invoice.success.message.invoice_emailed': 'This invoice will be emailed shortly.',
    'invoice.modal.message.email_invoice_message': 'Are you sure you want to send this invoice to {name}?',
};
